<template>
    <div>
        <ul class="input-table mt-3">
            <li
                class="row"
                v-for="(item, index) in items"
                :key="index"
            >
                <div class="col-md-1 pr-0">
                </div>
                <div class="d-flex input-table-shadow col-md-10 align-items-center">
                    <div class="col-2 border-right">
                        <input type="text" :placeholder="$t('services.inventory.compartment-name')" v-model="item.name" />
                    </div>
                    <div class="col-3 border-right">
                        <inventory-layout-seats
                            :seats.sync="item.amount"
                            :rollingStockSeats.sync="item.rollingStockSeats"
                        ></inventory-layout-seats>
                    </div>
                    <div class="col-4 border-right">
                        <core-drop-down
                            :class="seatStatus(item)"
                            :items="compartmentTypes"
                            :selectedValue.sync="item.serviceId"
                            v-model="item.serviceId"
                            noLabel
                            simpleValue
                        ></core-drop-down>
                    </div>
                    <div class="col-1 border-right">
                        <input type="text" :class="seatStatus(item)" :placeholder="$t('services.inventory.compartment-max-pax')" disabled :value="maxPax(item)" />
                    </div>
                    <div class="col-2" v-html="freeSeats(item)"></div>
                </div>
                <div class="pl-2 d-flex align-items-center">
                    <div class="d-flex align-items-center">
                        <core-icon
                            @click.native="clone(item)"
                            class="pointer"
                            :iconName="$t('general.clone')"
                            iconColor="#bdbdbd"
                        >
                            <icons-clone></icons-clone>
                        </core-icon>
                    </div>
                    <div class="pl-1 d-flex align-items-center">
                        <core-icon
                            @click.native="remove(index)"
                            class="pointer"
                            :iconName="$t('general.remove')"
                            iconColor="#bdbdbd"
                        >
                            <icons-delete></icons-delete>
                        </core-icon>
                    </div>
                </div>
            </li>
        </ul>
        <div class="ml-5 pl-3 mb-4 add-row">
            <img class="add-row" src="@/assets/svg/plus008CDD.svg" @click="add({ amount: null })" :title="$t('general.add')" />
        </div>
    </div>
</template>

<script>
import { addItem } from '@/mixins/addItem'
import { cloneItem } from '@/mixins/cloneItem'
import { removeItem } from '@/mixins/removeItem'
export default {
  props: {
    compartments: {
      type: Array,
      required: true
    },
    compartmentTypes: {
      type: Array,
      required: false
    }
  },
  data () {
    return {
      items: this.compartments,
      finishedInit: false
    }
  },
  mixins: [addItem, cloneItem, removeItem],
  methods: {
    maxPax (coupe) {
      let amount = 1
      if (!coupe.maxPax) {
        amount = coupe.totalSeats
      }
      return amount
    },
    freeSeats (coupe) {
      let occupied = coupe.totalSeats - coupe.freeSeats
      let text = ''
      if (occupied) {
        text += '<span class="status-occupied">' + occupied + ' pax'
        if (coupe.freeSeats) {
          text += ' | '
        }
        text += '</span>'
      }
      if (coupe.freeSeats) {
        text += '<span class="status-open">' + coupe.freeSeats + ' open</span>'
      }
      return text
    },
    seatStatus (coupe) {
      let occupied = coupe.totalSeats - coupe.freeSeats
      let status = ''
      if (occupied) {
        status = 'status-occupied'
      }
      if (!occupied && coupe.freeSeats) {
        status = 'status-open'
      }
      return status
    }
  }
}
</script>

<style scoped>
  div >>> .status-occupied,
  div >>> .status-occupied > select {
    color: #008CDD;
  }
  div >>> .status-open,
  div >>> .status-open > select {
    color: #6FCF97;
  }
</style>



// WEBPACK FOOTER //
// src/components/inventory/layout/Compartment.vue